import React from 'react';

export interface LatestDetection {
  id: string;
  cardId?: string;
  date: number;
  projectId: string;
  commandId: string;
  contextChange?: string;
}

interface SessionDetectionContextProps {
  latestDetection: LatestDetection | null;
  setLatestDetection: (detection: LatestDetection | null) => void;
}

export const SessionDetectionContext = React.createContext<SessionDetectionContextProps | null>(null);

export default function useSessionDetectionContext() {
  const context = React.useContext(SessionDetectionContext);
  if (context === null) {
    throw new Error('useSessionDetectionContext must be used within a SessionDetectionContextProvider');
  }
  return context;
}
